<br />
<mat-grid-list cols="1" rowHeight="35px">
  <mat-grid-tile rowspan="1">
    <h1 class="title">Roles</h1>
  </mat-grid-tile>
  <mat-grid-tile rowspan="2">
    <button mat-raised-button color="accent" (click)="openCreate()" appPermissionControl="P196B0001"><mat-icon class="icon">add</mat-icon>Nuevo</button>
  </mat-grid-tile>
  <mat-grid-tile rowspan="2">
    <mat-form-field color="accent" appearance="outline">
      <mat-label>Buscar</mat-label>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Ej. Admin" #input appPermissionControl="P196K0001" />
      <mat-icon matSuffix color="accent">search</mat-icon>
    </mat-form-field>
  </mat-grid-tile>
</mat-grid-list>

<div id="div" class="mat-elevation-z8 table-responsive">
  <table mat-table [dataSource]="dataSource" matSort appPermissionControl="P196T0001">
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef appPermissionControl="P196C0001">Acciones</th>
      <td mat-cell *matCellDef="let element" [ngStyle]="{ color: element.active ? 'black' : 'red' }">
        <button mat-icon-button [matMenuTriggerFor]="menu" appPermissionControl="P196B0002">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button (click)="openUpdate(element)" mat-menu-item appPermissionControl="P196B0003">
            <mat-icon>edit</mat-icon>
            <span>Editar</span>
          </button>
          <button (click)="delete(element)" mat-menu-item appPermissionControl="P196B0004">
            <mat-icon>delete</mat-icon>
            <span>Eliminar</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P196C0002">Código</th>
      <td mat-cell *matCellDef="let element" [ngStyle]="{ color: element.active ? 'black' : 'red' }">
        {{ element.id }}
      </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P196C0003">Rol</th>
      <td mat-cell *matCellDef="let element" [ngStyle]="{ color: element.active ? 'black' : 'red' }">
        {{ element.description }}
      </td>
    </ng-container>

    <ng-container matColumnDef="definition">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P196C0004">Descripción</th>
      <td mat-cell *matCellDef="let element" [ngStyle]="{ color: element.active ? 'black' : 'red' }">
        {{ element.definition }}
      </td>
    </ng-container>

    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P196C0005">Estado</th>
      <td mat-cell *matCellDef="let element" [ngStyle]="{ color: element.active ? 'black' : 'red' }">
        {{ element.active ? 'Activo' : 'Inactivo' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="userCreated">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P196C0006">Creado por</th>
      <td mat-cell *matCellDef="let element" [ngStyle]="{ color: element.active ? 'black' : 'red' }">
        {{ element.userCreated }}
      </td>
    </ng-container>

    <ng-container matColumnDef="dateCreated">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P196C0007">Fecha</th>
      <td mat-cell *matCellDef="let element" [ngStyle]="{ color: element.active ? 'black' : 'red' }">
        {{ element.dateCreated | date : 'dd/MM/yyyy' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="userModified">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P196C0008">Editado por</th>
      <td mat-cell *matCellDef="let element" [ngStyle]="{ color: element.active ? 'black' : 'red' }">
        {{ element.userModified ? element.userModified : 'N/A' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="dateModified">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P196C0009">Fecha</th>
      <td mat-cell *matCellDef="let element" [ngStyle]="{ color: element.active ? 'black' : 'red' }">
        {{ element.dateModified | date : 'dd/MM/yyyy' }}
        <span *ngIf="!element.dateModified">N/A</span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="20">
        <span *ngIf="allData > 0">No hay resultados para "{{ input.value }}"</span>
        <span *ngIf="allData == 0 && !loading">No hay datos para mostrar</span>
        <mat-spinner *ngIf="loading" class="spinner"></mat-spinner>
      </td>
    </tr>
  </table>
  <mat-paginator [pageSizeOptions]="[5, 10, 20, 40, 80, allData]" showFirstLastButtons class="paginatorTb"></mat-paginator>
</div>
